import * as z from "zod";

export const getFulfillmentsMetrics = {
  name: "getFulfillmentsMetrics" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    avgFulfillmentTime: z.number(),
    errorFulfillmentRate: z.number(),
    splitOrders: z.number(),
    totalWarehouses: z.number(),
  }),
};
